import { AXIS_META, axisFromCode } from './axis';

export function dimensionPath(code: string): string {
  const axis = axisFromCode(code);
  if (axis === 'st') return `/veca-pitanja/${code.toLowerCase()}`;
  if (axis === 'mo') return `/glasovi#${code.toLowerCase()}`;
  const meta = AXIS_META[axis];
  return `/${meta.pathSegment}/${code.toLowerCase()}`;
}

export function hubPath(axis: 'op' | 'sn'): string {
  return `/${AXIS_META[axis].pathSegment}`;
}

export function quotePath(id: string): string {
  return `/citat/${id}`;
}

export function sourcePath(rowId: number): string {
  return `/izvor/${rowId}`;
}

export function bmPath(opstina: string, bm: string): string {
  // Phase 2 — currently these routes don't exist yet
  const slug = opstina
    .toLowerCase()
    .replaceAll('đ', 'dj')
    .replaceAll('č', 'c')
    .replaceAll('ć', 'c')
    .replaceAll('š', 's')
    .replaceAll('ž', 'z')
    .replace(/[^a-z0-9-]+/g, '-');
  return `/biracko-mesto/${slug}/${bm}`;
}
